import {
  Avatar,
  AvatarGroup,
  Card,
  CardContent,
  Chip,
  Stack,
  Typography,
} from "@mui/joy";
import { useTeamCardQuery } from "../../__generated__/types-and-hooks";
import { Link as RouterLink } from "react-router-dom";
import Link from "@mui/joy/Link";
import UserAvatar from "../../components/UserAvatar";

export interface TeamKindChipProps {
  kind?: "BRAND" | "AGENCY" | string;
}

function TeamKindChip({ kind }: TeamKindChipProps) {
  return (
    <Chip variant="outlined" size="sm" color="primary">
      {kind}
    </Chip>
  );
}

export interface TeamUsersProps {
  teamId: number;
}

function TeamUsers({ teamId }: TeamUsersProps) {
  const teamCardQuery = useTeamCardQuery({ variables: { teamId } });
  const team = teamCardQuery.data?.team_by_id;
  return (
    <AvatarGroup>
      {team?.userEdges.slice(0, 3).map(({ user }) => (
        <UserAvatar key={user.id} userId={user.id} size="sm" />
      ))}
      {(team?.userEdges ?? []).length > 3 && (
        <Avatar variant="solid" size="sm">
          +{(team?.userEdges ?? []).length - 3}
        </Avatar>
      )}
    </AvatarGroup>
  );
}

export interface TeamCardProps {
  teamId: number;
  picture?: string | null;
  name: string;
  kind: string;
  slug: string;
  description?: string | null;
}

export default function TeamCard({
  teamId,
  picture,
  name,
  description,
  kind,
  slug,
}: TeamCardProps) {
  return (
    <Card
      variant="outlined"
      orientation="horizontal"
      sx={{
        background: "hsl(0deg 0% 31.06% / 35%)",
        "&:hover": {
          boxShadow: "md",
          borderColor: "neutral.outlinedHoverBorder",
          background: "hsl(0deg 0% 51.06% / 35%)",
        },
      }}
    >
      <Avatar
        size="sm"
        sx={{
          height: 36,
          // width: "100%",
          minWidth: 36,
          width: 36,
          borderRadius: 4,
        }}
        src={picture ? picture : "/images/qcsku_dark.jpg"}
      />

      <CardContent>
        <Typography level="title-lg" id="card-description">
          {name}
        </Typography>
        <TeamKindChip kind={kind} />
        <Link
          component={RouterLink}
          color="neutral"
          to={"/" + slug}
          overlay
          underline="none"
          sx={{ color: "text.tertiary" }}
        >
          <Stack direction="column">
            <Typography
              level="body-sm"
              aria-describedby="card-description"
              sx={{ mb: 1 }}
            >
              {description}
            </Typography>
            <TeamUsers teamId={teamId} />
          </Stack>
        </Link>
      </CardContent>
    </Card>
  );
}
